import { useQuery } from '@tanstack/react-query'
import { fetchActionPointsStatus, actionPointKeys } from '@/services/actionPoints'

/**
 * Hook to get action points status for a party.
 *
 * Returns the total AP available for the tick, AP spent on queued actions,
 * and the remaining available AP.
 *
 * @param partyId - The party to check (optional, hook is disabled if undefined)
 * @param currentTick - The current game tick (optional, hook is disabled if undefined)
 * @returns Object with total, spent, available AP, plus loading/error states
 */
export function useActionPoints(partyId: string | undefined, currentTick: number | undefined) {
  const query = useQuery({
    queryKey: actionPointKeys.byPartyTick(partyId!, currentTick!),
    queryFn: () => fetchActionPointsStatus(partyId!, currentTick!),
    enabled: !!partyId && currentTick !== undefined,
  })

  return {
    total: query.data?.total ?? 0,
    spent: query.data?.spent ?? 0,
    available: query.data?.available ?? 0,
    isLoading: query.isLoading,
    error: query.error,
  }
}
